const INITIAL_STATE = {
  funcaoList: [],
  funcao: null,
  funcaoFiltro: [],
  funcaoPesquisa: [],
  funcaoEdicao: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'FUNCAO_FETCH':
      return { ...state, funcaoList: action.payload }
    case 'FUNCAO_SET':
      return { ...state, funcao: action.payload }
    case 'FUNCAO_FILTRO':
      return { ...state, funcaoFiltro: action.payload }
    case 'FUNCAO_PESQUISA':
      return { ...state, funcaoPesquisa: action.payload }
    case 'FUNCAO_INDEX':
      console.log(action.payload, 'funcao')
      return { ...state, funcaoEdicao: action.payload }
    default:
      return state
  }
}